import { render, staticRenderFns } from "./AddressTag.vue?vue&type=template&id=b8f428fc&scoped=true"
import script from "./AddressTag.vue?vue&type=script&lang=js"
export * from "./AddressTag.vue?vue&type=script&lang=js"
import style0 from "./AddressTag.vue?vue&type=style&index=0&id=b8f428fc&prod&lang=scss&scoped=true"
import style1 from "./AddressTag.vue?vue&type=style&index=1&id=b8f428fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f428fc",
  null
  
)

export default component.exports